import { render, staticRenderFns } from "./ClipboardMethod.vue?vue&type=template&id=523c74b4&"
import script from "./ClipboardMethod.vue?vue&type=script&lang=js&"
export * from "./ClipboardMethod.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports